/*
 * Consent v2 (TDDDG § 25, DSGVO Art. 6/7) for every customer website, the webapp and the members area – design-independent,
 * styled through --cs-* custom properties (/css/consent.css, source css/scss/consent.scss). Spec: AppSystem-qa/rc14/design-spec.md §C.
 *
 * Config: <script type="application/json" id="hw-consent-config"> written by ConsentHead (Java) into the page head:
 *   {v, ctx: site|webapp|members|app|preview|none, site, anrede, lang, privacy, ga, pixel} – no config = embeds only.
 * Categories: Notwendig (always, listed from NECESSARY), Externe Medien (per service, two-click placeholders), Statistik (GA4) and
 * Marketing (Meta pixel) – the last two only on customer websites (ctx site) with a configured AND confirmed id.
 * 1. Embeds load only after a click: <div data-consent="youtube" data-src="…" data-title="…"></div>; widget scripts the same way with
 *    data-script="https://…" (+ data-script-id); Consent.require(id, box, load) runs load() when the service is allowed.
 *    „immer erlauben“ remembers the service.
 * 2. Banner (reject · choose · accept, equal weight) only when a site-wide service is configured and not decided for the current
 *    version / within 12 months / for the current service set. Nothing is stored before a click; nothing loads before consent.
 * 3. [data-consent-open] (footer link „Datenschutz-Einstellungen“) is always visible; pages without one get a fallback link next
 *    to their Datenschutz link. It opens the settings dialog (switches per category / service, revoke = cookies deleted + reload).
 * Decisions live in this browser only (localStorage hw-consent:<site>), nothing goes to the server.
 * The API is ready synchronously (webapp pages call it from inline scripts); every DOM step waits for DOMContentLoaded.
 */
(function () {
  'use strict';
  if (window.Consent) { return; } // a second include on the page

  var MAX_AGE = 365 * 864e5;
  var LEGACY = 'hw-consent';
  var doc = document;
  var root = doc.documentElement;

  function readConfig() {
    var c = null;
    try {
      var e = doc.getElementById('hw-consent-config');
      c = e ? JSON.parse(e.textContent) : null;
    } catch (err) { c = null; }
    if (!c || typeof c !== 'object') { c = { ctx: 'none', v: 1, site: null }; }
    if (typeof c.v !== 'number') { c.v = 1; }
    return c;
  }
  var cfg = readConfig();
  var ctx = cfg.ctx || 'none';
  var KEY = cfg.site != null && cfg.site !== '' ? LEGACY + ':' + cfg.site : LEGACY;

  // ---------------------------------------------------------------------------------------------- texts (consent-texts §2/§3)
  var T = {
    de: {
      load: 'Laden', always: '{s} immer erlauben', info: 'Datenschutzhinweise', video: 'Video laden', map: 'Karte laden', calendar: 'Kalender von {s} laden', audio: 'Audio von {s} laden',
      insecure: 'Dieser Inhalt hat keine sichere Adresse (https) und kann nicht geladen werden.',
      imgName: 'Bilder anderer Webseiten', imgLoad: 'Bild laden', imgAlways: 'Bilder anderer Webseiten immer erlauben',
      imgText: 'Dieses Bild wird von {h} geladen. Dabei werden Daten wie die IP-Adresse an den Anbieter übertragen.',
      text: 'Dieser Inhalt wird von {s} ({p}) geladen. Dabei werden Daten wie die IP-Adresse an den Anbieter übertragen.',
      settings: 'Datenschutz-Einstellungen',
      banner: 'Wir möchten mit deiner Einwilligung {d} nutzen, um {z}. Dabei werden Daten wie deine IP-Adresse und Kennungen in deinem Browser an {a} übertragen, auch in die USA. Du kannst frei wählen – die Webseite funktioniert auch ohne. Deine Auswahl kannst du jederzeit unter „Datenschutz-Einstellungen“ am Seitenende ändern.',
      more: 'Mehr in der Datenschutzerklärung', reject: 'Alle ablehnen', choose: 'Auswählen', accept: 'Alle akzeptieren',
      save: 'Auswahl speichern', close: 'Schließen', saved: 'Gespeichert.', alwaysOn: 'Immer aktiv',
      intro: 'Hier entscheidest du, welche Dienste wir nutzen dürfen. Notwendige Speicherungen lassen sich nicht abschalten, weil die Webseite sonst nicht funktioniert.',
      none: 'Diese Webseite lädt keine Dienste, für die eine Einwilligung nötig ist.',
      providerInfo: 'Datenschutzhinweise des Anbieters', storage: 'Speicherung', joint: 'gemeinsam verantwortlich', and: 'und',
      cat: {
        notwendig: ['Notwendig', 'Speichert z. B. deine Anmeldung im Mitgliederbereich, deine Sprache und deine Auswahl in diesen Einstellungen.'],
        medien: ['Externe Medien', 'Videos, Karten und Beiträge von Drittanbietern werden erst geladen, wenn du sie erlaubst. Dabei erhält der Anbieter deine IP-Adresse und kann Cookies setzen.'],
        statistik: ['Statistik', 'Hilft uns zu verstehen, wie die Webseite genutzt wird (Google Analytics).'],
        marketing: ['Marketing', 'Misst die Wirkung unserer Werbung auf Facebook und Instagram (Meta-Pixel).']
      },
      purpose: { statistik: 'zu verstehen, wie unsere Webseite genutzt wird', marketing: 'die Wirkung unserer Werbung auf Facebook und Instagram zu messen',
        both: 'zu verstehen, wie unsere Webseite genutzt wird, und die Wirkung unserer Werbung zu messen' },
      pixel: 'das Meta-Pixel', months13: '13 Monate', days90: '90 Tage'
    },
    en: {
      load: 'Load', always: 'Always allow {s}', info: 'Privacy information', video: 'Load video', map: 'Load map', calendar: 'Load calendar from {s}', audio: 'Load audio from {s}',
      insecure: 'This content has no secure address (https) and cannot be loaded.',
      imgName: 'images from other websites', imgLoad: 'Load image', imgAlways: 'Always allow images from other websites',
      imgText: 'This image is loaded from {h}. Data such as your IP address is sent to the provider.',
      text: 'This content is loaded from {s} ({p}). Data such as your IP address is sent to the provider.',
      settings: 'Privacy settings',
      banner: 'With your consent we would like to use {d} to {z}. Data such as your IP address and identifiers in your browser are sent to {a}, including to the USA. It is your choice – the website works without it. You can change your choice at any time under “Privacy settings” at the bottom of the page.',
      more: 'More in the privacy policy', reject: 'Reject all', choose: 'Choose', accept: 'Accept all',
      save: 'Save choice', close: 'Close', saved: 'Saved.', alwaysOn: 'Always active',
      intro: 'Here you decide which services we may use. Necessary storage cannot be switched off because the website would not work without it.',
      none: 'This website loads no services that need your consent.',
      providerInfo: 'Privacy information of the provider', storage: 'Storage', joint: 'joint controllers', and: 'and',
      cat: {
        notwendig: ['Necessary', 'Stores, for example, your login to the members area, your language and your choice in these settings.'],
        medien: ['External media', 'Videos, maps and posts of third parties load only when you allow them. The provider then receives your IP address and may set cookies.'],
        statistik: ['Statistics', 'Helps us understand how the website is used (Google Analytics).'],
        marketing: ['Marketing', 'Measures the effect of our advertising on Facebook and Instagram (Meta pixel).']
      },
      purpose: { statistik: 'understand how our website is used', marketing: 'measure the effect of our advertising on Facebook and Instagram',
        both: 'understand how our website is used and measure the effect of our advertising' },
      pixel: 'the Meta pixel', months13: '13 months', days90: '90 days'
    },
    // PL: translated in RC14, native review pending (rc14/handover-o.md)
    pl: {
      load: 'Wczytaj', always: 'Zawsze zezwalaj na {s}', info: 'Informacje o prywatności', video: 'Wczytaj wideo', map: 'Wczytaj mapę', calendar: 'Wczytaj kalendarz z {s}', audio: 'Wczytaj audio z {s}',
      insecure: 'Ta treść nie ma bezpiecznego adresu (https) i nie może zostać załadowana.',
      imgName: 'obrazy z innych stron', imgLoad: 'Wczytaj obraz', imgAlways: 'Zawsze zezwalaj na obrazy z innych stron',
      imgText: 'Ten obraz jest wczytywany z {h}. Dane, np. adres IP, są przekazywane dostawcy.',
      text: 'Ta treść jest wczytywana z {s} ({p}). Dane, np. adres IP, są przekazywane dostawcy.',
      settings: 'Ustawienia prywatności',
      banner: 'Za Twoją zgodą chcielibyśmy korzystać z {d}, aby {z}. Dane, takie jak Twój adres IP i identyfikatory w przeglądarce, są przy tym przekazywane do {a}, także do USA. Możesz swobodnie wybrać – strona działa również bez tego. Swój wybór możesz w każdej chwili zmienić w „Ustawieniach prywatności” na dole strony.',
      more: 'Więcej w polityce prywatności', reject: 'Odrzuć wszystko', choose: 'Wybierz', accept: 'Zaakceptuj wszystko',
      save: 'Zapisz wybór', close: 'Zamknij', saved: 'Zapisano.', alwaysOn: 'Zawsze aktywne',
      intro: 'Tutaj decydujesz, z jakich usług możemy korzystać. Niezbędnego zapisu danych nie można wyłączyć, ponieważ bez niego strona nie działa.',
      none: 'Ta strona nie wczytuje żadnych usług, które wymagają zgody.',
      providerInfo: 'Informacje o prywatności dostawcy', storage: 'Zapis danych', joint: 'współadministratorzy', and: 'i',
      cat: {
        notwendig: ['Niezbędne', 'Zapisuje np. Twoje logowanie do strefy członków, Twój język i Twój wybór w tych ustawieniach.'],
        medien: ['Media zewnętrzne', 'Filmy, mapy i posty zewnętrznych dostawców wczytują się dopiero po Twojej zgodzie. Dostawca otrzymuje wtedy Twój adres IP i może zapisać pliki cookie.'],
        statistik: ['Statystyka', 'Pomaga nam zrozumieć, jak korzystasz ze strony (Google Analytics).'],
        marketing: ['Marketing', 'Mierzy skuteczność naszych reklam na Facebooku i Instagramie (Piksel Meta).']
      },
      purpose: { statistik: 'zrozumieć, jak korzystasz z naszej strony', marketing: 'mierzyć skuteczność naszych reklam na Facebooku i Instagramie',
        both: 'zrozumieć, jak korzystasz z naszej strony, i mierzyć skuteczność naszych reklam' },
      pixel: 'Piksela Meta', months13: '13 miesięcy', days90: '90 dni'
    }
  };
  // Sie (kunden-anrede: config anrede "sie" or <html data-anrede="sie">): only the sentences with a pronoun differ
  T.deSie = Object.assign({}, T.de, {
    banner: 'Wir möchten mit Ihrer Einwilligung {d} nutzen, um {z}. Dabei werden Daten wie Ihre IP-Adresse und Kennungen in Ihrem Browser an {a} übertragen, auch in die USA. Sie können frei wählen – die Webseite funktioniert auch ohne. Ihre Auswahl können Sie jederzeit unter „Datenschutz-Einstellungen“ am Seitenende ändern.',
    intro: 'Hier entscheiden Sie, welche Dienste wir nutzen dürfen. Notwendige Speicherungen lassen sich nicht abschalten, weil die Webseite sonst nicht funktioniert.',
    cat: Object.assign({}, T.de.cat, {
      notwendig: ['Notwendig', 'Speichert z. B. Ihre Anmeldung im Mitgliederbereich, Ihre Sprache und Ihre Auswahl in diesen Einstellungen.'],
      medien: ['Externe Medien', 'Videos, Karten und Beiträge von Drittanbietern werden erst geladen, wenn Sie sie erlauben. Dabei erhält der Anbieter Ihre IP-Adresse und kann Cookies setzen.']
    })
  });
  var lang = String(cfg.lang || root.getAttribute('lang') || 'de').slice(0, 2).toLowerCase();
  if (!T[lang]) { lang = 'de'; }
  var sie = lang === 'de' && (cfg.anrede === 'sie' || root.getAttribute('data-anrede') === 'sie');
  var t = sie ? T.deSie : T[lang];
  function f(s, o) { return s.replace(/\{(\w)\}/g, function (m, k) { return o[k] || ''; }); }
  function tr(o) { return o ? (sie && o.sie) || o[lang] || o.de : ''; }

  // ---------------------------------------------------------------------------------------------- necessary storage registry
  // Single source for the „Notwendig“ list (consent-texts §4); the e2e check consent.storage-list compares what a visit wrote.
  // Visitor counters that needed consent were removed in RC14 §X instead of being listed here.
  function row(n, ty, de, sieText, en, pl, dur) { return { n: n, ty: ty, p: { de: de, sie: sieText, en: en, pl: pl }, d: dur }; }
  var D12M = { de: '12 Monate', en: '12 months', pl: '12 miesięcy' };
  var DSESSION = { de: 'Browsersitzung', en: 'browser session', pl: 'sesja przeglądarki' };
  var D12H = { de: '12 Stunden', en: '12 hours', pl: '12 godzin' };
  var D10MIN = { de: '10 Minuten', en: '10 minutes', pl: '10 minut' };
  var BASE_ROWS = [
    row(LEGACY, 'localStorage', 'deine Auswahl in den Datenschutz-Einstellungen', 'Ihre Auswahl in den Datenschutz-Einstellungen',
      'your choice in the privacy settings', 'Twój wybór w ustawieniach prywatności', D12M),
    row('__Host-hwsid', 'Cookie', 'Sitzung – nur wenn du Formulare, Mitgliederbereich oder Terminbuchung nutzt',
      'Sitzung – nur wenn Sie Formulare, Mitgliederbereich oder Terminbuchung nutzen',
      'session – only when you use forms, the members area or appointment booking',
      'sesja – tylko gdy korzystasz z formularzy, strefy członków lub rezerwacji terminów', DSESSION),
    // RC47 O5: functional language cookie of the website (only after a language choice)
    row('hw_lang', 'Cookie', 'merkt sich die gewählte Sprache der Website', 'merkt sich die gewählte Sprache der Website',
      'remembers the language chosen for the website', 'zapamiętuje wybrany język strony', DSESSION),
    // RC68 O1: page password unlock (PageLock.COOKIE, TTL_MINUTES = 12 h) – site, members and webapp
    row('hw_pu', 'Cookie', 'merkt sich, dass du eine geschützte Seite mit ihrem Passwort geöffnet hast',
      'merkt sich, dass Sie eine geschützte Seite mit ihrem Passwort geöffnet haben',
      'remembers that you opened a protected page with its password', 'zapamiętuje otwarcie chronionej strony hasłem', D12H),
    // RC75 O1: form token of the website forms (PublicFormPost.COOKIE, on https __Host-hw_ft, 12 h) – strictly necessary, no personal data
    row('hw_ft', 'Cookie', 'schützt deine Formulare vor fremden Absendern', 'schützt Ihre Formulare vor fremden Absendern',
      'protects your forms against senders from other sites', 'chroni Twoje formularze przed nadawcami z innych stron', D12H)
  ];
  var MEMBER_ROWS = [
    row('communityLoggedIn', 'Cookie', 'merkt sich, dass du angemeldet bist', 'merkt sich, dass Sie angemeldet sind',
      'remembers that you are logged in', 'zapamiętuje, że jesteś zalogowany', DSESSION),
    row('tokenCommunity, userCommunity, rememberCommunity', 'localStorage', '„Angemeldet bleiben“', '„Angemeldet bleiben“',
      '“Stay logged in”', '„Nie wylogowuj mnie”', { de: 'bis zur Abmeldung', en: 'until you log out', pl: 'do wylogowania' }),
    // RC77 (security delta 2 mi-4): set only when a member connects Google or Apple in the profile, read once on the way back
    row('oidc_link', 'Cookie', 'verbindet dein Google- oder Apple-Konto sicher mit deinem Profil', 'verbindet Ihr Google- oder Apple-Konto sicher mit Ihrem Profil',
      'links your Google or Apple account safely to your profile', 'bezpiecznie łączy Twoje konto Google lub Apple z profilem', { de: '10 Minuten', en: '10 minutes', pl: '10 minut' }),
    // RC74 A4-O7: Facebook-Anmeldung (FacebookLogin.COOKIE, COOKIE_MAX_AGE = 600 s) – only while a sign-in with Facebook runs
    row('fb_oauth_state', 'Cookie', 'merkt sich kurz deine Anmeldung mit Facebook', 'merkt sich kurz Ihre Anmeldung mit Facebook',
      'briefly remembers your sign-in with Facebook', 'krótko zapamiętuje logowanie przez Facebooka', D10MIN)
  ];
  var WEBAPP_ROWS = [
    row('lastVisit', 'Cookie', 'zeigt dir, was seit deinem letzten Besuch neu ist', 'zeigt Ihnen, was seit Ihrem letzten Besuch neu ist',
      'shows you what is new since your last visit', 'pokazuje, co nowego od Twojej ostatniej wizyty', { de: '90 Tage', en: '90 days', pl: '90 dni' }),
    row('wa.prefs.v1', 'localStorage', 'deine Darstellung (z. B. hell oder dunkel)', 'Ihre Darstellung (z. B. hell oder dunkel)',
      'your display settings (e.g. light or dark)', 'Twoje ustawienia wyglądu (np. jasny lub ciemny)', { de: 'bis du sie löschst', en: 'until you delete it', pl: 'do usunięcia' }),
    row('wa.install.dismissed', 'localStorage', 'du hast den Hinweis „App installieren“ geschlossen', 'Sie haben den Hinweis „App installieren“ geschlossen',
      'you closed the „Install app“ hint', 'zamknięto wskazówkę „Zainstaluj aplikację“', { de: 'bis du ihn löschst', en: 'until you delete it', pl: 'do usunięcia' }),
    row('wa.install.ios', 'sessionStorage', 'Anleitung zum Installieren auf dem iPhone wurde gezeigt', 'Anleitung zum Installieren auf dem iPhone wurde gezeigt',
      'the iPhone install guide was shown', 'pokazano instrukcję instalacji na iPhonie', DSESSION),
    row('Service-Worker-Cache', 'Cache Storage', 'Seiten der Web-App offline verfügbar', 'Seiten der Web-App offline verfügbar',
      'web app pages available offline', 'strony aplikacji dostępne offline', { de: 'bis zur nächsten Version', en: 'until the next version', pl: 'do następnej wersji' }),
    row('Push-Abo', 'Push API', 'nur wenn du Mitteilungen erlaubst', 'nur wenn Sie Mitteilungen erlauben',
      'only when you allow notifications', 'tylko gdy zezwolisz na powiadomienia', { de: 'bis du sie abschaltest', en: 'until you switch them off', pl: 'do wyłączenia' })
  ];
  var NECESSARY = { site: BASE_ROWS, members: BASE_ROWS.concat(MEMBER_ROWS), webapp: BASE_ROWS.concat(MEMBER_ROWS, WEBAPP_ROWS) };
  function necessary() { return NECESSARY[ctx] || NECESSARY.site; }

  // ---------------------------------------------------------------------------------------------- services
  var GOOGLE = 'https://policies.google.com/privacy';
  var services = {
    youtube: { name: 'YouTube', provider: 'Google Ireland Ltd.', privacy: GOOGLE, kind: 'video' },
    vimeo: { name: 'Vimeo', provider: 'Vimeo.com Inc.', privacy: 'https://vimeo.com/privacy', kind: 'video' },
    // RC61 O2: TikTok videos of the Social-Media-Seite (TikTok's iframe player in its own origin, only after consent)
    tiktok: { name: 'TikTok', provider: 'TikTok Technology Limited', privacy: 'https://www.tiktok.com/legal/page/eea/privacy-policy/de', kind: 'video' },
    googlemaps: { name: 'Google Maps', provider: 'Google Ireland Ltd.', privacy: GOOGLE, kind: 'map' },
    // RC74 A4-O7: an ajax update re-renders the page box while the SDK is already on the page – parse the new box
    facebook: { name: 'Facebook', provider: 'Meta Platforms Ireland Ltd.', privacy: 'https://www.facebook.com/privacy/policy/',
      reparse: function (box) { /** @type {any} */ var fb = /** @type {any} */ (window).FB; if (fb && fb.XFBML) { fb.XFBML.parse(box); } } },
    // RC77 A4-O3: three more click-to-load embeds (server: ContentIframes, only their embed paths)
    googlecalendar: { name: 'Google Kalender', by: 'Google', provider: 'Google Ireland Ltd.', privacy: GOOGLE, kind: 'calendar' },
    openstreetmap: { name: 'OpenStreetMap', provider: 'OpenStreetMap Foundation', privacy: 'https://osmfoundation.org/wiki/Privacy_Policy', kind: 'map' },
    spotify: { name: 'Spotify', provider: 'Spotify AB', privacy: 'https://www.spotify.com/de/legal/privacy-policy/', kind: 'audio' },
    twitter: { name: 'X (Twitter)', provider: 'Twitter International Unlimited Company', privacy: 'https://x.com/de/privacy' },
    extern: { name: lang === 'en' ? 'an external website' : lang === 'pl' ? 'zewnętrznej strony' : 'einer externen Webseite', provider: '', privacy: '' },
    // RC49 O1b: images of other websites in customer HTML (server: ContentIframes → <span class="cs-img" data-consent="extimg">)
    extimg: { name: (T[lang] || T.de).imgName, provider: '', privacy: '', kind: 'image' }
  };
  var used = {};
  var pending = {}; // id -> loaders waiting behind a placeholder (run when the service is allowed in the dialog)

  // ---------------------------------------------------------------------------------------------- decision
  function readKey(k) {
    try { var v = window.localStorage.getItem(k); return v ? JSON.parse(v) : null; } catch (e) { return null; }
  }
  function isV2(o) { return !!o && typeof o === 'object' && typeof o.v === 'number' && !!o.cat && typeof o.cat === 'object'; }
  var stored = readKey(KEY);
  if (!isV2(stored)) { stored = null; }
  // mem = what applies on this page; storage is written only on a click (commit)
  var mem = { cat: { statistik: false, marketing: false }, svc: {} };
  var fresh = !!stored && stored.v >= cfg.v && !(Date.now() - Date.parse(stored.ts) > MAX_AGE);
  if (fresh) { mem.svc = Object.assign({}, stored.svc || {}); }
  // legacy flat {youtube: true} under the host-wide key (live template sites before RC14): while this site has no decision of
  // its own, those embed choices still apply (read on use); the legacy key is never changed – another site on the same origin may
  // read it – and its choices move into the site key with the visitor's next click (commit)
  function legacySvc() {
    if (stored || KEY === LEGACY) { return {}; }
    var l = readKey(LEGACY);
    var src = l && (isV2(l) ? l.svc || {} : l);
    var out = {};
    if (src && typeof src === 'object') {
      Object.keys(src).forEach(function (id) { if (src[id] === true && services[id] && !services[id].global) { out[id] = true; } });
    }
    return out;
  }

  // a site-wide service without a category (older callers) counts as Statistik – for the banner and for allowed()
  function categoryOf(id) { var s = services[id]; return s && s.global ? (s.category === 'marketing' ? 'marketing' : 'statistik') : null; }
  function setIdOf(id) { return (services[id] && services[id].setId) || id; }
  function globals() { return Object.keys(services).filter(function (id) { return services[id].global; }); }
  function configuredSet() { return globals().map(setIdOf); }
  // the stored category choice counts only when it is fresh and was made for every configured site-wide service
  function decided() {
    if (!fresh || !stored) { return false; }
    var set = stored.set || [];
    return configuredSet().every(function (s) { return set.indexOf(s) >= 0; });
  }
  function syncCats() {
    var ok = decided();
    mem.cat.statistik = ok && stored.cat.statistik === true;
    mem.cat.marketing = ok && stored.cat.marketing === true;
  }
  syncCats();

  function allowed(id) {
    var c = categoryOf(id);
    return c ? mem.cat[c] === true : mem.svc[id] === true || legacySvc()[id] === true;
  }

  /* Writes the decision – only ever called from a click. catsDecided: the visitor chose the categories with this click. */
  function commit(catsDecided) {
    var l = legacySvc();
    Object.keys(l).forEach(function (id) { if (!(id in mem.svc)) { mem.svc[id] = true; } });
    var keep = !catsDecided && decided();
    var set = catsDecided ? configuredSet() : keep ? stored.set : [];
    var cat = catsDecided || keep ? { statistik: mem.cat.statistik, marketing: mem.cat.marketing } : { statistik: false, marketing: false };
    stored = { v: cfg.v, ts: new Date().toISOString(), cat: cat, svc: Object.assign({}, mem.svc), set: set };
    fresh = true;
    try { window.localStorage.setItem(KEY, JSON.stringify(stored)); } catch (e) { /* storage blocked: the decision lasts for the page */ }
  }

  // ---------------------------------------------------------------------------------------------- loaders (after consent only)
  var me = doc.currentScript || doc.querySelector('script[src*="/js/consent.js"]');
  var BASE = '';
  try { BASE = me ? new URL(me.getAttribute('src'), location.href).pathname.replace(/\/js\/consent\.js.*$/, '') : ''; } catch (e) { BASE = ''; }
  var ran = {};

  function addScript(src) {
    var s = doc.createElement('script');
    s.async = true;
    s.src = src;
    (doc.head || root).appendChild(s);
  }

  /* GA4 basic consent mode: no Google request before this runs; signals and ad personalisation off; cookies on the exact host. */
  function loadGa(id) {
    if (ran.ga) { return; }
    ran.ga = true;
    window['ga-disable-' + id] = false;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
    window.gtag('consent', 'default', { ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied', analytics_storage: 'granted' });
    window.gtag('js', new Date());
    window.gtag('config', id, { allow_google_signals: false, allow_ad_personalization_signals: false, cookie_domain: location.hostname,
      cookie_expires: 34190000, cookie_path: BASE + '/' });
    addScript('https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(id));
  }

  /* Meta pixel without advanced matching and without automatic event setup; one PageView per page load. */
  function loadPixel(id) {
    if (ran.pixel) { return; }
    ran.pixel = true;
    if (!window.fbq) {
      /** @type {any} */ var n = window.fbq = function () { if (n.callMethod) { n.callMethod.apply(n, arguments); } else { n.queue.push(arguments); } };
      if (!window._fbq) { window._fbq = n; }
      n.push = n; n.loaded = true; n.version = '2.0'; n.queue = [];
    }
    window.fbq('set', 'autoConfig', false, id);
    window.fbq('init', id, {});
    window.fbq('track', 'PageView');
    addScript('https://connect.facebook.net/' + ({ en: 'en_US', pl: 'pl_PL' }[lang] || 'de_DE') + '/fbevents.js');
  }

  var COOKIES = { statistik: /^(_ga(_.*)?|_gid)$/, marketing: /^(_fbp|_fbc)$/ };
  /* Revoke: the provider's first-party cookies we know, on the host, .host and without domain, for / and the context path. */
  function dropCookies(cat) {
    var names = { statistik: ['_ga', '_gid'], marketing: ['_fbp', '_fbc'] }[cat].slice();
    if (cat === 'statistik' && cfg.ga) { names.push('_ga_' + String(cfg.ga).replace(/^G-/, '')); }
    // RC42 O1: document.cookie throws a SecurityError in an opaque (sandboxed) origin – revoke then only stops the tools
    try {
      doc.cookie.split(';').forEach(function (c) {
        var n = c.split('=')[0].trim();
        if (COOKIES[cat].test(n) && names.indexOf(n) < 0) { names.push(n); }
      });
      var host = location.hostname;
      var paths = ['/'];
      if (BASE) { paths.push(BASE + '/', BASE); }
      names.forEach(function (n) {
        paths.forEach(function (p) {
          ['', host, '.' + host].forEach(function (d) {
            doc.cookie = n + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; max-age=0; path=' + p + (d ? '; domain=' + d : '');
          });
        });
      });
    } catch (e) { /* no cookie access here */ }
    if (cat === 'statistik' && cfg.ga) { window['ga-disable-' + cfg.ga] = true; }
  }

  function runAllowed() {
    globals().forEach(function (id) {
      var s = services[id];
      if (allowed(id) && s.onAllow && !s.started) { s.started = true; s.onAllow(); }
    });
  }

  // site-wide services: only on customer websites, only with an id in the expected format (ConsentHead sends confirmed ids only)
  if (ctx === 'site' && /^G-[A-Z0-9]{4,15}$/.test(cfg.ga || '')) {
    services.analytics = { global: true, category: 'statistik', setId: 'ga', name: 'Google Analytics 4', bannerName: 'Google Analytics',
      short: 'Google', provider: 'Google Ireland Ltd.', privacy: GOOGLE, cookies: '_ga, _ga_<ID>', duration: 'months13',
      onAllow: function () { loadGa(cfg.ga); } };
  }
  if (ctx === 'site' && /^[0-9]{10,20}$/.test(cfg.pixel || '')) {
    services.metapixel = { global: true, category: 'marketing', setId: 'pixel', name: 'Meta-Pixel', bannerName: t.pixel, short: 'Meta',
      provider: 'Meta Platforms Ireland Ltd.', joint: true, privacy: 'https://www.facebook.com/privacy/policy/', cookies: '_fbp',
      duration: 'days90', onAllow: function () { loadPixel(cfg.pixel); } };
  }
  syncCats();

  // ---------------------------------------------------------------------------------------------- DOM helpers
  function css() {
    if (doc.getElementById('cs-css')) { return; }
    var l = doc.createElement('link');
    l.id = 'cs-css'; l.rel = 'stylesheet'; l.href = BASE + '/css/min/consent.css?v=7'; // compressed build (batch 2, RC78 S row 31)
    (doc.head || root).appendChild(l);
  }
  function el(tag, cls, text) {
    var e = doc.createElement(tag);
    if (cls) { e.className = cls; }
    if (text != null) { e.textContent = text; }
    return e;
  }
  function button(cls, text, action) {
    var b = el('button', cls, text);
    b.type = 'button';
    if (action) { b.setAttribute('data-cs-action', action); }
    return b;
  }
  var domReady = doc.readyState !== 'loading';

  // ---------------------------------------------------------------------------------------------- embeds
  /* A placeholder in box; run() when the visitor allows (once or always). */
  function placeholder(box, id, run) {
    // RC74 A4-O7: an address that is neither https nor this site can never load – say so instead of a „Laden“ that does nothing
    var raw = box.getAttribute('data-src') || box.getAttribute('data-script');
    if (raw != null && !safeUrl(raw)) { insecure(box); return; }
    var s = services[id] || { name: id, provider: '' };
    used[id] = true;
    var done = false;
    function go() {
      if (done) { return; }
      done = true;
      box.innerHTML = '';
      box.classList.remove('cs-embed');
      run();
    }
    (pending[id] = pending[id] || []).push(go);
    box.classList.add('cs-embed');
    box.innerHTML = '';
    var p = el('div', 'cs-embed__panel');
    p.appendChild(el('p', 'cs-embed__text', f(t.text, { s: s.name, p: s.provider || '' }).replace(' ()', '')));
    var actions = el('div', 'cs-embed__actions');
    var btn = button('cs-btn', s.kind === 'video' ? t.video : s.kind === 'map' ? t.map
      : s.kind === 'calendar' || s.kind === 'audio' ? f(t[s.kind], { s: s.by || s.name }) : t.load);
    var keep = el('label', 'cs-embed__always');
    var cb = el('input'); cb.type = 'checkbox';
    keep.appendChild(cb); keep.appendChild(doc.createTextNode(' ' + f(t.always, { s: s.name })));
    actions.appendChild(btn); actions.appendChild(keep);
    p.appendChild(actions);
    if (s.privacy) {
      var a = el('a', 'cs-embed__info', t.info); a.href = s.privacy; a.target = '_blank'; a.rel = 'noopener';
      p.appendChild(a);
    }
    box.appendChild(p);
    btn.addEventListener('click', function () {
      if (cb.checked) { mem.svc[id] = true; commit(false); }
      go();
    });
  }

  /* data-src / data-script allow-list (sec14-consent-datasrc, security review S1-1): parsed like the browser does (backslashes, tab/CR/LF),
     only https: or the same origin is accepted; returns the normalised href or null. */
  /* RC74 A4-O7: the hint for an embed without a secure address (no load button; never upgraded to https silently). */
  function insecure(box) {
    box.classList.add('cs-embed');
    box.innerHTML = '';
    var p = el('div', 'cs-embed__panel');
    p.appendChild(el('p', 'cs-embed__text', t.insecure));
    box.appendChild(p);
  }

  function safeUrl(u) {
    if (typeof u !== 'string') { return null; }
    var x;
    try { x = new URL(u.trim(), location.href); } catch (e) { return null; }
    if (x.username || x.password) { return null; }
    return (x.protocol === 'https:' || x.origin === location.origin) ? x.href : null;
  }

  function iframe(box, o) {
    var safe = safeUrl(o.src);
    if (!safe) { return; }
    var fr = doc.createElement('iframe');
    fr.src = safe;
    fr.title = o.title || '';
    fr.loading = 'lazy';
    if (o.allow) { fr.setAttribute('allow', o.allow); }
    fr.setAttribute('allowfullscreen', '');
    // the author's restrictions of a server-rewritten embed (ContentIframes: data-sandbox / data-referrerpolicy, o3 m7)
    if (o.sandbox != null) { fr.setAttribute('sandbox', o.sandbox); }
    if (o.referrerpolicy) { fr.setAttribute('referrerpolicy', o.referrerpolicy); }
    var mw = maxWidth(box);
    if (mw) { fr.style.maxWidth = mw; }
    box.appendChild(fr);
  }

  /* RC77 fb-plugin-width: data-cs-maxw (server: digits, 200–600) as a px max-width, else null. */
  function maxWidth(box) {
    var v = box.getAttribute('data-cs-maxw');
    return v && /^[0-9]{3}$/.test(v) ? v + 'px' : null;
  }

  /* An iframe of a service (o: src, title, allow) in box: right away if allowed, else after the click. */
  function embed(box, id, o) {
    css();
    var mw = maxWidth(box);
    if (mw) { box.style.maxWidth = mw; }
    used[id] = true;
    if (box.hasAttribute('data-sandbox') && o.sandbox == null) { o.sandbox = box.getAttribute('data-sandbox'); }
    if (box.hasAttribute('data-referrerpolicy') && !o.referrerpolicy) { o.referrerpolicy = box.getAttribute('data-referrerpolicy'); }
    // allowed: the box may hold the server's fallback link (ContentIframes) – the iframe replaces it
    if (allowed(id)) {
      if (!safeUrl(o.src)) { insecure(box); return; }
      box.innerHTML = ''; iframe(box, o); return;
    }
    placeholder(box, id, function () { iframe(box, o); });
  }

  /* RC49 O1b: a third-party image box (inline span): the image right away when allowed, else a small inline placeholder (spans – the
     box may sit inside a paragraph) with „Bild laden“ and „immer erlauben“. The server's fallback link stays for pages without JS. */
  function image(box) {
    css();
    var id = 'extimg';
    used[id] = true;
    var o = { src: box.getAttribute('data-src'), alt: box.getAttribute('data-alt') || '', host: box.getAttribute('data-host') || '' };
    function show() {
      var safe = safeUrl(o.src);
      if (!safe) { return; }
      var img = doc.createElement('img');
      img.src = safe; img.alt = o.alt; img.loading = 'lazy'; img.decoding = 'async'; img.referrerPolicy = 'no-referrer';
      var ar = box.style.getPropertyValue('--cs-ar');
      if (ar) { img.style.aspectRatio = ar; }
      box.replaceWith(img);
    }
    if (allowed(id)) { show(); return; }
    var done = false;
    (pending[id] = pending[id] || []).push(function () { if (!done) { done = true; show(); } });
    box.innerHTML = '';
    box.classList.add('cs-img--box');
    var p = el('span', 'cs-img__panel');
    p.appendChild(el('span', 'cs-img__text', f(t.imgText, { h: o.host })));
    var actions = el('span', 'cs-img__actions');
    var btn = button('cs-btn', t.imgLoad);
    if (o.alt) { btn.setAttribute('aria-label', t.imgLoad + ': ' + o.alt); }
    var keep = el('label', 'cs-embed__always');
    var cb = el('input'); cb.type = 'checkbox';
    keep.appendChild(cb); keep.appendChild(doc.createTextNode(' ' + t.imgAlways));
    actions.appendChild(btn); actions.appendChild(keep);
    p.appendChild(actions);
    box.appendChild(p);
    btn.addEventListener('click', function () {
      if (!done) { done = true; show(); }
      // „immer erlauben“: every other image box of the page loads too
      if (cb.checked) { mem.svc[id] = true; commit(false); (pending[id] || []).forEach(function (go) { go(); }); }
    });
  }

  /* Run load() when the service is allowed – now, or after the click on the placeholder shown in box. */
  function require(id, box, load) {
    css();
    used[id] = true;
    if (allowed(id)) { load(); return; }
    placeholder(box, id, load);
  }

  /* <div data-consent="facebook" data-script="https://…/sdk.js" data-script-id="facebook-jssdk">: a widget script (SDK) only after
     consent – the box shows the placeholder until then; one script per id on the page. */
  function scriptAfterConsent(box) {
    var src = box.getAttribute('data-script');
    var sid = box.getAttribute('data-script-id');
    src = safeUrl(src);
    if (!src || !/^https:/.test(src)) { css(); insecure(box); return; }
    var id = box.getAttribute('data-consent');
    require(id, box, function () {
      if (sid && doc.getElementById(sid)) {
        // RC74 A4-O7: the SDK is already here (an ajax update re-rendered the box) – let the service parse the new box
        var sv = services[id];
        if (sv && sv.reparse) { sv.reparse(box); }
        return;
      }
      var s = doc.createElement('script');
      s.async = true;
      if (sid) { s.id = sid; }
      s.src = src;
      (doc.body || root).appendChild(s);
    });
  }

  /* Google Maps of the old templates / native app pages (sec14-maps-oldtpl): the page marks every script that needs the Maps API as
     <script type="text/x-consent-maps" [data-src="https://…"] [data-box="id"]> (the browser does not run that type). Nothing loads until the
     service "googlemaps" is allowed (placeholder in the data-box element, else in a div before the first marked script); then the
     marked scripts run in document order – external ones are awaited – so the original page code is unchanged. */
  var MAPS_HOSTS = ['maps.google.com', 'maps.googleapis.com'];
  function mapsUrl(u) {
    var h = safeUrl(u), x;
    if (!h) { return null; }
    x = new URL(h);
    return (x.origin === location.origin || MAPS_HOSTS.indexOf(x.hostname) >= 0) ? h : null;
  }
  /* S2-6: the API loaded without callback= may not have google.maps.Map ready at onload (loader modes): wait for it (max ~5 s), via
     importLibrary where the new loader offers it, then run the page code either way. */
  function mapsReady(next) {
    var n = 0, fin = false, guard;
    // S3-7: next runs exactly once; a hard timeout covers an importLibrary promise that never settles
    function go() { if (fin) { return; } fin = true; clearTimeout(guard); next(); }
    guard = setTimeout(go, 5000);
    (function check() {
      if (fin) { return; }
      var g = window.google && window.google.maps;
      if (g && g.Map) { go(); return; }
      if (g && g.importLibrary && n === 0) { n++; try { g.importLibrary('maps').then(check, go); return; } catch (e) { /* poll below */ } }
      if (++n > 50) { go(); return; }
      setTimeout(check, 100);
    })();
  }
  function gatedMaps() {
    // S2-4: only our own hidden span markers count, and only Google Maps hosts or the page's own origin are loaded
    var libs = doc.querySelectorAll('span[hidden][data-consent-maps-src]:not([data-cs-ready])');
    var codes = doc.querySelectorAll('script[type="text/x-consent-maps"]:not([data-cs-ready])');
    if (!libs.length && !codes.length) { return; }
    var items = [], box = null, i;
    // external libraries first (span markers: PrimeFaces moves <script> tags to the page end and drops empty ones), then the inline code
    for (i = 0; i < libs.length; i++) { items.push(libs[i]); }
    for (i = 0; i < codes.length; i++) { items.push(codes[i]); }
    for (i = 0; i < items.length; i++) {
      items[i].setAttribute('data-cs-ready', '1');
      if (!box && items[i].getAttribute('data-box')) { box = doc.getElementById(items[i].getAttribute('data-box')); }
    }
    if (!box) {
      box = doc.createElement('div');
      items[0].parentNode.insertBefore(box, items[0]);
    }
    function step(k) {
      if (k >= items.length) { return; }
      var it = items[k], src = it.getAttribute('data-consent-maps-src'), s = doc.createElement('script');
      if (src) {
        var u = mapsUrl(src);
        if (!u) { step(k + 1); return; }
        s.onload = function () { /maps\.goo/.test(u) ? mapsReady(function () { step(k + 1); }) : step(k + 1); };
        s.onerror = function () { step(k + 1); };
        s.src = u;
        (doc.body || root).appendChild(s);
      } else {
        s.text = it.text;
        (doc.body || root).appendChild(s);
        step(k + 1);
      }
    }
    require('googlemaps', box, function () { step(0); });
  }

  // ---------------------------------------------------------------------------------------------- footer link
  function linkContexts() { return ctx === 'site' || ctx === 'members' || ctx === 'webapp' || ctx === 'preview'; }
  function settingsLinks() {
    var links = doc.querySelectorAll('[data-consent-open]');
    for (var i = 0; i < links.length; i++) { if (links[i].hasAttribute('hidden')) { links[i].removeAttribute('hidden'); } }
    if (links.length) { css(); }   // template-provided buttons need consent.css too (without a banner nothing else loads it: unstyled default button, worst in Firefox)
    if (links.length || !linkContexts() || !doc.body) { return; }
    css();
    // fallback for templates without a [data-consent-open]: next to the last Datenschutz link, else at the end of the footer
    var b = button('cs-settings-link', t.settings);
    b.setAttribute('data-consent-open', '');
    var ds = doc.querySelectorAll('a[href$="/datenschutz/"]');
    var last = ds.length ? ds[ds.length - 1] : null;
    var item = /** @type {any} */ (last && last.parentNode);
    if (item && item.nodeName === 'LI') {
      var li = item.cloneNode(false);
      li.removeAttribute('id');
      li.classList.remove('active');
      li.appendChild(b);
      item.parentNode.insertBefore(li, item.nextSibling);
    } else if (last) {
      item.insertBefore(b, last.nextSibling);
      item.insertBefore(doc.createTextNode(' '), b);
    } else {
      var p = el('p', 'cs-footer-fallback');
      p.appendChild(b);
      var footers = doc.getElementsByTagName('footer');
      (footers.length ? footers[footers.length - 1] : doc.body).appendChild(p);
    }
  }

  // ---------------------------------------------------------------------------------------------- banner
  var padBase = null; // the body's own inline padding-bottom before the banner
  function pad() {
    var b = doc.getElementById('cs-banner');
    if (!b) { return; }
    if (padBase === null) { padBase = doc.body.style.paddingBottom || ''; }
    doc.body.style.paddingBottom = b.offsetHeight + 'px'; // no content hides behind the banner
  }
  function removeBanner() {
    var b = doc.getElementById('cs-banner');
    if (b) { b.parentNode.removeChild(b); }
    if (padBase !== null) { doc.body.style.paddingBottom = padBase; padBase = null; }
  }
  function joinList(arr) {
    return arr.length < 2 ? arr.join('') : arr.slice(0, -1).join(', ') + ' ' + t.and + ' ' + arr[arr.length - 1];
  }
  function bannerText() {
    var ids = globals();
    var cats = {};
    ids.forEach(function (id) { cats[categoryOf(id)] = true; });
    var names = ids.map(function (id) { return services[id].bannerName || services[id].name; });
    var shorts = [];
    ids.forEach(function (id) { var s = services[id].short || services[id].provider || services[id].name; if (shorts.indexOf(s) < 0) { shorts.push(s); } });
    var z = cats.statistik && cats.marketing ? t.purpose.both : cats.marketing ? t.purpose.marketing : t.purpose.statistik;
    return f(t.banner, { d: joinList(names), z: z, a: joinList(shorts) });
  }
  function setCats(on) {
    globals().forEach(function (id) { mem.cat[categoryOf(id)] = on; });
  }
  /* Q14-3: the banner comes first in the Tab order – right after the skip link(s), else first in body. It is position:fixed, so its place
     in the DOM changes only the reading/Tab order, never the layout – unless an ancestor would become the fixed box's containing block
     (transform/filter/contain): then after that ancestor's top-level box, or first in body. Nothing is focused on load. */
  function place(b) {
    var body = doc.body;
    var skip = body.querySelector('a[href="#skipToMain"], a[href="#waMain"], a[class*="skip"]');
    if (!skip) { body.insertBefore(b, body.firstChild); return; }
    var end = skip;
    while (end.nextElementSibling && end.nextElementSibling.matches('a[href^="#"]')) { end = end.nextElementSibling; }
    var par = /** @type {Element} */ (end.parentNode);
    if (par !== body && !par.querySelector(':scope > :not(a[href^="#"])')) { end = par; } // a <nav> that holds only skip links
    /** @type {any} */ var top = end; var fixedOk = true;
    for (/** @type {any} */ var a = /** @type {any} */ (end.parentNode); a && a !== body; a = a.parentNode) {
      var cs = window.getComputedStyle(a);
      if (cs.transform !== 'none' || cs.filter !== 'none' || cs.perspective !== 'none' || /paint|layout|strict|content/.test(cs.contain || '')) { fixedOk = false; }
      if (a.parentNode === body) { top = a; }
    }
    if (fixedOk) { end.parentNode.insertBefore(b, end.nextSibling); return; }
    var main = doc.querySelector('main, [role="main"]');
    if (top !== end && main && top.contains(main)) { body.insertBefore(b, body.firstChild); return; }
    body.insertBefore(b, top.nextSibling);
  }
  /* RC42 O1: inside a frame (Inhalte preview „Ansehen“, opaque origin) no banner – the decision stays „none“, so no site-wide
     tool loads and the embeds keep their placeholders. */
  function framed() {
    try { return window.self !== window.top; } catch (e) { return true; }
  }
  function banner() {
    if (!domReady || !doc.body || !globals().length || decided() || doc.getElementById('cs-banner') || framed()) { return; }
    css();
    var b = el('section', 'cs-banner'); b.id = 'cs-banner';
    b.setAttribute('role', 'region');
    b.setAttribute('aria-labelledby', 'cs-banner-title');
    var h = el('h2', 'cs-banner__title', t.settings); h.id = 'cs-banner-title';
    b.appendChild(h);
    var p = el('p', 'cs-banner__text', bannerText() + ' ');
    var more = el('a', 'cs-banner__more', t.more);
    more.href = cfg.privacy || (BASE + '/datenschutz/');
    p.appendChild(more);
    b.appendChild(p);
    var actions = el('div', 'cs-banner__actions');
    actions.appendChild(button('cs-btn', t.reject, 'reject'));
    actions.appendChild(button('cs-btn', t.choose, 'choose'));
    actions.appendChild(button('cs-btn', t.accept, 'accept'));
    b.appendChild(actions);
    actions.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-cs-action]') : null;
      if (!a) { return; }
      var act = a.getAttribute('data-cs-action');
      if (act === 'choose') { openSettings(a); return; }
      setCats(act === 'accept');
      commit(true);
      removeBanner();
      runAllowed();
    });
    place(b);
    pad();
    if (window.ResizeObserver) { new ResizeObserver(pad).observe(b); } else { window.addEventListener('resize', pad); }
  }

  // ---------------------------------------------------------------------------------------------- settings dialog
  var opener = null;
  /* A switch; its accessible name is the category / service name (label text, visually hidden next to the visible name). */
  function sw(attr, value, label, checked) {
    var l = el('label', 'cs-switch');
    var i = el('input', 'cs-switch__input');
    i.type = 'checkbox';
    i.setAttribute('role', 'switch');
    i.setAttribute(attr, value);
    i.checked = checked;
    l.appendChild(i);
    l.appendChild(el('span', 'cs-switch__track'));
    l.appendChild(el('span', 'cs-sr', label));
    return l;
  }
  function serviceRow(id, withSwitch) {
    var s = services[id];
    var li = el('li', 'cs-dialog__item');
    var body = el('div', 'cs-dialog__body');
    body.appendChild(el('span', 'cs-dialog__name', s.name));
    var meta = [];
    if (s.provider) { meta.push(s.provider + (s.joint ? ' (' + t.joint + ')' : '')); }
    if (s.cookies) { meta.push(t.storage + ': ' + s.cookies + (s.duration ? ', ' + t[s.duration] : '')); }
    if (meta.length) { body.appendChild(el('span', 'cs-dialog__meta', meta.join(' · '))); }
    if (s.privacy) {
      var a = el('a', 'cs-dialog__link', t.providerInfo); a.href = s.privacy; a.target = '_blank'; a.rel = 'noopener';
      body.appendChild(a);
    }
    li.appendChild(body);
    if (withSwitch) { li.appendChild(sw('data-cs-svc', id, s.name, allowed(id))); }
    return li;
  }
  function category(key, side, rows, open) {
    var c = el('div', 'cs-dialog__cat');
    var d = el('details', 'cs-dialog__details');
    if (open) { d.open = true; }
    d.appendChild(el('summary', 'cs-dialog__catname', t.cat[key][0]));
    d.appendChild(el('p', 'cs-dialog__catdesc', t.cat[key][1]));
    if (rows) { d.appendChild(rows); }
    c.appendChild(d);
    if (side) { c.appendChild(side); }
    return c;
  }
  function necessaryList() {
    var ul = el('ul', 'cs-dialog__list');
    necessary().forEach(function (r) {
      var li = el('li', 'cs-dialog__item');
      var body = el('div', 'cs-dialog__body');
      body.appendChild(el('span', 'cs-dialog__name', r.n));
      body.appendChild(el('span', 'cs-dialog__meta', r.ty + ' · ' + tr(r.p) + ' · ' + tr(r.d)));
      li.appendChild(body);
      ul.appendChild(li);
    });
    return ul;
  }

  function openSettings(from) {
    css();
    opener = from || (doc.activeElement && doc.activeElement !== doc.body ? doc.activeElement : null);
    /** @type {any} */ var d = doc.getElementById('cs-dialog');
    if (d) { if (d.open && d.close) { d.close(); } d.parentNode.removeChild(d); }
    d = el('dialog', 'cs-dialog'); d.id = 'cs-dialog';
    d.setAttribute('aria-labelledby', 'cs-dialog-title');
    var h = el('h2', 'cs-dialog__title', t.settings); h.id = 'cs-dialog-title';
    d.appendChild(h);
    d.appendChild(el('p', 'cs-dialog__intro', t.intro));

    var media = Object.keys(services).filter(function (id) { return !services[id].global && (used[id] || allowed(id)); });
    var gl = globals();
    var empty = !media.length && !gl.length;
    if (empty) { d.appendChild(el('p', 'cs-dialog__empty', t.none)); }
    d.appendChild(category('notwendig', el('span', 'cs-dialog__always', t.alwaysOn), necessaryList(), empty));
    if (media.length) {
      var ul = el('ul', 'cs-dialog__list');
      media.forEach(function (id) { ul.appendChild(serviceRow(id, true)); });
      d.appendChild(category('medien', null, ul, true));
    }
    ['statistik', 'marketing'].forEach(function (cat) {
      var ids = gl.filter(function (id) { return categoryOf(id) === cat; });
      if (!ids.length) { return; }
      var list = el('ul', 'cs-dialog__list');
      ids.forEach(function (id) { list.appendChild(serviceRow(id, false)); });
      d.appendChild(category(cat, sw('data-cs-cat', cat, t.cat[cat][0], mem.cat[cat] === true), list, false));
    });

    var actions = el('div', 'cs-dialog__actions');
    if (empty) {
      actions.appendChild(button('cs-btn', t.close, 'close'));
    } else {
      actions.appendChild(button('cs-btn', t.reject, 'reject'));
      actions.appendChild(button('cs-btn', t.save, 'save'));
      actions.appendChild(button('cs-btn', t.accept, 'accept'));
    }
    d.appendChild(actions);
    var status = el('p', 'cs-status');
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    d.appendChild(status);

    actions.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('[data-cs-action]') : null;
      if (!a) { return; }
      var act = a.getAttribute('data-cs-action');
      if (act === 'close') { d.close(); return; }
      var inputs = /** @type {NodeListOf<HTMLInputElement>} */ (d.querySelectorAll('.cs-switch__input'));
      if (act !== 'save') {
        for (var i = 0; i < inputs.length; i++) { inputs[i].checked = act === 'accept'; }
      }
      save(d, inputs, status);
    });
    // focus stays in the dialog (showModal makes the page inert; this also wraps Tab at both ends)
    d.addEventListener('keydown', function (e) {
      // Escape closes without saving – handled here because template scripts (lumen app.js …) preventDefault every Escape on
      // the document, which would cancel the native close
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); e.stopPropagation(); d.close(); return; }
      if (e.key !== 'Tab') { return; }
      var all = d.querySelectorAll('summary, a[href], button, input');
      var vis = [];
      for (var i = 0; i < all.length; i++) { if (all[i].getClientRects().length) { vis.push(all[i]); } }
      if (!vis.length) { return; }
      /** @type {any} */ var first = vis[0], last = vis[vis.length - 1];
      if (e.shiftKey && doc.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    d.addEventListener('close', function () {
      if (opener && opener.focus && doc.contains(opener)) { opener.focus(); }
    });
    doc.body.appendChild(d);
    if (d.showModal) { d.showModal(); } else { d.setAttribute('open', ''); }
  }

  function save(d, inputs, status) {
    var l = legacySvc();
    Object.keys(l).forEach(function (id) { if (!(id in mem.svc)) { mem.svc[id] = true; } });
    var revoked = [];
    var granted = false;
    for (var i = 0; i < inputs.length; i++) {
      var x = inputs[i];
      var cat = x.getAttribute('data-cs-cat');
      var id = x.getAttribute('data-cs-svc');
      if (cat) {
        if (mem.cat[cat] && !x.checked) { revoked.push(cat); }
        if (!mem.cat[cat] && x.checked) { granted = true; }
        mem.cat[cat] = x.checked;
      } else if (id) {
        if (mem.svc[id] && !x.checked) { revoked.push(id); delete mem.svc[id]; }
        else if (!mem.svc[id] && x.checked) {
          mem.svc[id] = true;
          (pending[id] || []).splice(0).forEach(function (run) { run(); });
        }
      }
    }
    commit(globals().length > 0);
    removeBanner();
    status.textContent = t.saved;
    revoked.forEach(function (c) { if (COOKIES[c]) { dropCookies(c); } });
    if (revoked.length) {
      setTimeout(function () { window.location.reload(); }, 600); // after the screen reader announced „Gespeichert.“
      return;
    }
    if (granted) { runAllowed(); }
    setTimeout(function () { if (d.open) { d.close(); } }, 600);
  }

  doc.addEventListener('click', function (e) {
    var tg = /** @type {any} */ (e.target);
    var o = tg.closest ? tg.closest('[data-consent-open]') : null;
    if (!o) { return; }
    e.preventDefault();
    openSettings(o.matches('button, a') ? o : (o.querySelector('button, a') || o));
  });

  // ---------------------------------------------------------------------------------------------- page set-up
  function scan() {
    if (!domReady) { return; }
    var list = doc.querySelectorAll('[data-consent][data-src]:not([data-cs-ready]), [data-consent][data-script]:not([data-cs-ready])');
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      b.setAttribute('data-cs-ready', '1');
      if (b.hasAttribute('data-script')) { scriptAfterConsent(b); continue; }
      if (b.getAttribute('data-consent') === 'extimg') { image(b); continue; }
      embed(b, b.getAttribute('data-consent'), { src: b.getAttribute('data-src'), title: b.getAttribute('data-title'), allow: b.getAttribute('data-allow') });
    }
    gatedMaps();
    settingsLinks();
    banner();
  }

  window.Consent = {
    version: cfg.v,
    /** A further service; {global: true, category: 'statistik'|'marketing', onAllow: fn} for site-wide tools (banner). */
    register: function (id, def) {
      services[id] = def;
      syncCats();
      if (def.global && allowed(id) && def.onAllow && !def.started) { def.started = true; def.onAllow(); }
      banner();
    },
    allowed: allowed,
    embed: embed,
    require: require,
    open: function () { openSettings(); },
    scan: scan,
    /** Read-only copy of the stored decision (support, tests); null when none. */
    decision: function () { return stored ? JSON.parse(JSON.stringify(stored)) : null; }
  };

  runAllowed();
  function ready() { domReady = true; scan(); }
  if (domReady) { ready(); } else { doc.addEventListener('DOMContentLoaded', ready); }
  // pages that add or replace content later (webapp shell, ajax updates): set up new embeds and links as they appear
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued || !domReady) { return; }
      queued = true;
      setTimeout(function () { queued = false; scan(); }, 50);
    }).observe(root, { childList: true, subtree: true });
  }
})();
